import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Globals} from "../../global/globals";
import {Observable} from "rxjs";
import {SharedService} from "../common/shared.service";
import {FormOptionsLists} from "../../shared/FormOptionsLists";
import {CanDoStatementEntry} from "../../dtos/can-do-statement/entry/can-do-statement-entry";
import {CanDoStatementEntryPage} from "../../dtos/can-do-statement/entry/can-do-statement-entry-page";
import {CanDoStatementEntryCreationDto} from "../../dtos/can-do-statement/entry/can-do-statement-entry-creation-dto";
import {cdsEntryAsArray} from "./global-can-do-statement.service";

@Injectable({
  providedIn: 'root'
})
export class DetailedCanDoStatementService {
  private detailedCDStatementBaseUri: string = this.globals.backendUri + '/cds/detailed';

  formOptionsLists = new FormOptionsLists();

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  /* -------------------- entries -------------------- */

  // any necessary for service injection into generic table component
  searchEntries(params: HttpParams): Observable<any> {
    return this.httpClient.get<CanDoStatementEntryPage>(this.detailedCDStatementBaseUri + '/entries', {params});
  }

  getEntry(id: number): Observable<any> {
    return this.httpClient.get<CanDoStatementEntry>(this.detailedCDStatementBaseUri + '/entries/' + id);
  }

  createEntry(entry: CanDoStatementEntryCreationDto): Observable<CanDoStatementEntry> {
    return this.httpClient.post<CanDoStatementEntry>(this.detailedCDStatementBaseUri + '/entries', entry);
  }

  updateEntry(id: number, entry: CanDoStatementEntryCreationDto): Observable<CanDoStatementEntry> {
    return this.httpClient.put<CanDoStatementEntry>(this.detailedCDStatementBaseUri + '/entries/' + id, entry);
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.detailedCDStatementBaseUri + '/entries/' + id);
  }

  getEntryAsArray(entry: CanDoStatementEntry) {
    return cdsEntryAsArray(entry, this.sharedService, this.formOptionsLists);
  }
}
